import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['image'];

  prepare() {
    // An image upload advances to grid detection within this dialog. Name-only
    // and video updates retain the ordinary close-on-success behavior.
    const type = this.imageTarget.files[0]?.type;
    this.element.dataset.modalCloseOnSubmit = String(!type?.startsWith('image/'));
  }
}
